// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import OutlinedCounterCard from "examples/Cards/CounterCards/OutlinedCounterCard";
import Auth from "components/Auth/Auth";
import { Card } from "@mui/material";
import { useEffect, useState } from "react";
import _ from "lodash";
import ApiService from "services/ApiService";

function Dashboard(props) {
  const [todayInvoicesCount, setTodayInvoiceCount] = useState(0);
  const [todayInvoicesSum, setTodayInvoiceSum] = useState(0);

  const getStats = async () => {
    const response = await ApiService.getData(`/api/v1/invoices/today`);
    setTodayInvoiceCount(_.get(response, "data.invoiceCount"));
    setTodayInvoiceSum(_.get(response, "data.invoiceSum", 0));
  };

  useEffect(() => {
    getStats();
  }, []);

  return (
    <DashboardLayout>
      <Auth accessLevel={props && props.accessLevel ? props.accessLevel : 0} />
      <DashboardNavbar />
      <SoftBox my={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox p={2}>
              <SoftBox mb={1}>
                <SoftTypography variant="h5" fontWeight="medium">
                  Στατιστικά
                </SoftTypography>
              </SoftBox>
              <SoftTypography variant="body2" fontWeight="regular" color="text">
                Παρακολουθήστε τα στατιστικά διαβίβασης για τις εταιρείες σας.
              </SoftTypography>
            </SoftBox>
            <SoftBox p={2}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <OutlinedCounterCard
                    count={todayInvoicesCount}
                    prefix=""
                    title="Σημερινές Διαβιβάσεις Παραστατικών"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <OutlinedCounterCard
                    count={todayInvoicesSum.toFixed(2)}
                    prefix="€"
                    decimals="2"
                    title="Σημερινό Σύνολο Αξίας Παραστατικών"
                  />
                </Grid>
              </Grid>
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
